/* eslint-disable no-debugger */
import { messageNotification } from "./function";

let lastLogoutNotificationTime = 0;
const LOGOUT_THRESHOLD = 2000; // 2 seconds

export const transformResponseHandler = async (resp, alert = true) => {
  // 0) If the returned user is an admin, show "User not found" error and bail
  const role = resp.data?.role;
  if (role === 'admin') {
    await messageNotification('User not found', 'error');
    return {
      status: resp.status,
      data: resp.data,
      total: resp.total,
      extra_meta: resp.extra_meta,
      ...(resp.token && { token: resp.token }),
    };
  }

  const statusCode = resp.data?.status ?? resp.status;
  const isLogoutStatus = statusCode === 403 || statusCode === 555;

  let shouldShowAlert = alert;
  if (isLogoutStatus) {
    const now = Date.now();
    if (now - lastLogoutNotificationTime < LOGOUT_THRESHOLD) {
      shouldShowAlert = false;
    } else {
      lastLogoutNotificationTime = now;
    }
  }

  // 1) Handle 401/501: error toast only
  if (
    shouldShowAlert &&
    (resp.status === 401 ||
      resp.data?.status === 401 ||
      resp.status === 501 ||
      resp.data?.status === 501)
  ) {
    await messageNotification(resp.data?.message || resp.message, 'error');
  }
  // 2) General alerts for all other messages
  else if (shouldShowAlert && (resp.message || resp.data?.message)) {
    const isError = statusCode >= 400;
    await messageNotification(
      resp.data?.message || resp.message,
      isError ? 'error' : 'success'
    );
  }

  // 3) Logout on status 555 or 403
  if (
    resp.status === 555 ||
    resp.data?.status === 555 ||
    resp.status === 403 ||
    resp.data?.status === 403
  ) {
    const { store } = await import('store/store');
    const { removePOSData } = await import('pages/login/services');
    store.dispatch(removePOSData());
  }

  // 4) Build transformed response
  const transformedResp = {
    status: resp.status,
    data: resp.data,
    total: resp.total,
    extra_meta: resp.extra_meta,
  };
  if (resp.token) {
    transformedResp.token = resp.token;
  }

  return transformedResp;
};
